/**
 * Задания (Quests) — shared types for the admin editor and forum
 * components. Quest DEFINITIONS live in the forumaker-arena.quests
 * settings JSON blob (see backend Quest\QuestManager); this file only
 * describes their shape and which config fields each type needs, mirroring
 * QuestConditionInterface::getConfigFields() type-by-type.
 */

// Type-keyed fallbacks for a quest's icon/color when the admin hasn't set
// its own (see Quest['color']/Quest['icon'] below) — shared between
// QuestsModal (forum rendering) and ArenaAdminPage (editor preview) so both
// sides agree on what a quest looks like before any override is applied.
export const QUEST_TYPE_ICONS = {
  play_card: 'fas fa-layer-group',
  heal_total: 'fas fa-heart',
  mana_restored_total: 'fas fa-gem',
  resonance_success_count: 'fas fa-bolt',
  poison_damage_total: 'fas fa-skull-crossbones',
  consecutive_days_played: 'fas fa-calendar-check',
  reflect_damage_total: 'fas fa-undo',
  mana_steal_total: 'fas fa-hand-holding-water',
  overload_damage_total: 'fas fa-crosshairs'
};

// Every plain hex (not a CSS var()) since getContrastColor() needs to read
// real RGB out of it to pick dark/light text/icons for the accented footer
// strip — same requirement applies to an admin's custom quest.color.
// 9 types share 6 colors, grouped loosely by theme: blue for card/reflect
// play, a second blue for mana, red for damage-over-time/burst, green for
// healing, orange for the daily streak, gold for Resonance's bolt.
export const QUEST_TYPE_COLORS = {
  play_card: '#3F6F8D',
  reflect_damage_total: '#3F6F8D',
  mana_restored_total: '#45698D',
  mana_steal_total: '#45698D',
  poison_damage_total: '#A7253D',
  overload_damage_total: '#A7253D',
  heal_total: '#80b77e',
  consecutive_days_played: '#fda371',
  resonance_success_count: '#ffcb7f'
};
export const QUEST_RARITIES = ['easy', 'medium', 'hard'];
/** True once `quest.deadline` has passed — see the field's own docblock. */
export function questIsExpired(quest, now) {
  if (now === void 0) {
    now = new Date();
  }
  return !!quest.deadline && new Date(quest.deadline) <= now;
}
export const QUEST_TYPES = ['play_card', 'poison_damage_total', 'consecutive_days_played', 'mana_steal_total', 'reflect_damage_total', 'heal_total', 'resonance_success_count', 'overload_damage_total', 'mana_restored_total'];
export function questNeedsCardConfig(type) {
  return type === 'play_card';
}

/**
 * Parses the raw forumaker-arena.quests setting/attribute (string or
 * already-decoded array) into a clean list, dropping malformed entries and
 * filling defaults — mirrors QuestManager::getQuests()'s leniency
 * server-side.
 */
export function normalizeQuests(raw) {
  let parsed = raw;
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw || '[]');
    } catch {
      parsed = [];
    }
  }
  if (!Array.isArray(parsed)) return [];
  return parsed.filter(q => q && typeof q.type === 'string').map(q => ({
    id: Number(q.id) || 0,
    type: q.type,
    target: Math.max(1, Math.floor(Number(q.target)) || 1),
    config: q.config && typeof q.config === 'object' ? q.config : {},
    reward_tokens: Math.max(0, Math.floor(Number(q.reward_tokens)) || 0),
    title: String(q.title || ''),
    description: q.description ? String(q.description) : undefined,
    deadline: q.deadline ? String(q.deadline) : null,
    is_active: q.is_active !== false,
    rarity: QUEST_RARITIES.includes(q.rarity) ? q.rarity : 'medium',
    color: q.color ? String(q.color) : undefined,
    icon: q.icon ? String(q.icon) : undefined
  }));
}
flarum.reg.add('forumaker-arena', 'common/quests', { QUEST_TYPE_ICONS: QUEST_TYPE_ICONS,QUEST_TYPE_COLORS: QUEST_TYPE_COLORS,QUEST_RARITIES: QUEST_RARITIES,questIsExpired: questIsExpired,QUEST_TYPES: QUEST_TYPES,questNeedsCardConfig: questNeedsCardConfig,normalizeQuests: normalizeQuests, });